<p-table #dt [value]="filteredTableData" [tableStyle]="tableStyle" [pageLinks]="pageLinks" [paginator]="!tableConfig?.hasSizeOffset && !totalRecords && tableData.length > numRows && filteredTableData.length > numRows" [rows]="rows"
    [rowsPerPageOptions]="[5, 10, 25, 50]" [responsiveLayout]="responsiveLayout" [styleClass]="styleClass" [first]="first"
    [globalFilterFields]="globalFilterFields" [(selection)]="selectedRow" paginatorDropdownAppendTo="body"
    (onPage)="pageChange($event)" (onHeaderCheckboxToggle)="headerCheckboxChange($event)" (onRowSelect)="rowSelectUnselectChange($event)" (onRowUnselect)="rowSelectUnselectChange($event)">
    <ng-template pTemplate="header">
        <tr>
            <th *ngIf="tableConfig?.hasSerialNumberColumn" style="width: 50px;" id="columnSerialNumber">
                S.No
            </th>
            <th *ngFor="let col of columns; let i = index" id="table" [ngStyle]="getColumnHeaderStyle(col)">
                <div class="flex align-items-center gap-2">
                   <div class="flex flex-1 align-items-center gap-2 relative z-1">
                    <p-tableHeaderCheckbox *ngIf="col.hasCheckbox"/>           
                    <p-sortIcon *ngIf="col.hasSort" [field]="col.key" [pSortableColumn]="col.hasSort ? (col.sortingKey || col.key) : ''"></p-sortIcon>
                    <span class="flex-auto flex-1" [ngClass]="col.isMultilineHeader ? 'white-space-pre-line text-center' : 'white-space-nowrap'">{{ col.label }}<small class="text-red-500" *ngIf="col?.isMandatory">*</small></span>
                    </div>
                    <ng-container *ngIf="col.hasMultiFilter">
                    <p-multiSelect #multiSelect 
                        [style]="{ visibility: 'hidden' }" 
                        class="max-h-0 max-w-0"  
                        panelStyleClass="table-multiselect" 
                        [(ngModel)]="col.value" 
                        [options]="getNestedValue(tableDataObj, col.key)" 
                        [showToggleAll]="true"
                        (onChange)="filterTable(col.key, $event.value)" 
                        appendTo="body" 
                        [filter]="true"
                        filterPlaceHolder="Search value" 
                        resetFilterOnHide="true">
                       
                        <ng-template pTemplate="headercheckboxicon" let-allSelected let-partialSelected="partialSelected">
                            <i-tabler class="ti-lg ti-regular" name="check" *ngIf="!partialSelected" [ngStyle]="{color:'var(--p-surface-0)'}"></i-tabler>
                            <i-tabler class="ti-lg ti-regular" name="minus" *ngIf="partialSelected" [ngStyle]="{ color: 'var(--text-color)' }"></i-tabler>
                        </ng-template>
                    
                    </p-multiSelect>

                    <p-button  
                        [styleClass]="(filters[col.key].length > 0) ? 'button-filter text-primary-500' : 'button-filter'"
                        icon="ti ti-filter" 
                        (click)="openDropdown(multiSelect)" 
                        text="true" 
                        severity="secondary" 
                        onkeypress="" 
                        [ariaLabel]="col.label">
                        <i-tabler name="filter"></i-tabler>
                    </p-button>
                </ng-container>

                </div>
            </th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex" let-index="index">
        <tr [ngClass]="tableId === 'ticket-dashboard' ? (rowData?.is_read ? 'mail-read' : 'font-medium') : ''">
          <td *ngIf="tableConfig && tableConfig?.hasSerialNumberColumn">
                 {{tableConfig.hasSizeOffset ? (rows * (first / rows)) + rowIndex + 1 : rowIndex + 1}}
             </td>
            <ng-container *ngFor="let col of columns;let i = index ">
                <ng-container *ngIf="col.templateName; else defaultTemplate">
                    <ng-container
                        *ngTemplateOutlet="customTemplates[col.templateName]; context:{rowData: rowData, index:index, rowIndex:rowIndex}">
                    </ng-container>
                </ng-container>
                <ng-template #defaultTemplate>
                    <td>
                @if(col.hasCheckbox){
                      <p-tableCheckbox [value]="rowData" />
                }
                @else if(col.hasSerialNo){
                    
                        {{rowIndex + 1}}
                } @else if(col.isDateTypeColumn) {
                            {{ getNestedBodyValue(rowData, col?.key) | customDatePipe}}
                        } 
                        @else {
                        {{ getNestedBodyValue(rowData, col?.key) }}
                        }

                    </td>
                </ng-template>
            </ng-container>
        </tr>
        <ng-container *ngIf="rowData?.showSubIntentTable">
            <ng-container
                        *ngTemplateOutlet="customTemplates['subIntentTable']; context:{rowData: rowData, index:index, rowIndex:rowIndex}">
            </ng-container>
        </ng-container>
    </ng-template>
    <ng-template pTemplate="emptymessage">
        <tr>
            <td [attr.colspan]="(tableConfig && tableConfig.hasSerialNumberColumn) ?columns.length + 1 : columns.length" class="empty-message">
                <div *ngIf="tableId != 'utterances'" class="text-center p-3 text-500">
                    {{ metricCard ? 'Your ' + metricCard + ' tab is empty.' : 'No Data is found.' }}
                  </div>
                  <div *ngIf="tableId == 'utterances'" class="text-center p-3 text-red-500">
                    <i class="ti ti-alert-circle"></i> This intent requires at least {{ minimumEntry }} training phrases for the intent model to identify accurate intent.
                  </div>                  
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="paginatorleft">
        {{first+1}} to {{(first + rows) > tableData.length ? tableData.length :  first + rows}}
    </ng-template>

</p-table>
<div class="flex" *ngIf="paginator && !tableConfig?.hasSizeOffset && totalRecords > numRows && tableId!=='utterances'">
    <div class="p-paginator-left-content">
        {{first+1}} to {{(first + rows) > totalRecords ? totalRecords :  first + rows }} 
    </div>
    <div>
        <p-paginator (onPageChange)="pageChange($event)" [pageLinkSize]="3" [first]="first" [rows]="rows" dropdownAppendTo="body" [totalRecords]="totalRecords"
            [rowsPerPageOptions]="[5, 10, 25, 50]">
        </p-paginator>
    </div>
</div>

<div *ngIf="paginator && tableConfig?.hasSizeOffset && totalRecords > (tableConfig?.initialRows ?? 10) && tableId!=='utterances'" class="card flex align-items-center">
    <div class="p-paginator-left-content">
        {{ first + 1 }} to {{  (first + rows) > totalRecords ? totalRecords :  first + rows }}
    </div>
    <div>
        <p-paginator (onPageChange)="pageChange($event)" [pageLinkSize]="3" [first]="first" [rows]="rows" dropdownAppendTo="body" [totalRecords]="totalRecords" 
            [rowsPerPageOptions]="[5, 10, 25, 50]">
        </p-paginator>
    </div>
</div>
